import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import { ContextPageData } from '../../context/PageData/index.js';
import { isPrerendering } from '../../utils/isPrerendering.js';
const IntercomUpdater = (props) => {
    const { viewer } = React.useContext(ContextPageData);
    const { update } = useIntercom();
    const location = useLocation();
    const updateIntercom = React.useCallback(() => {
        if (viewer) {
            update({
                email: viewer.email &&
                    (viewer.email.endsWith('facebook.com') || viewer.email.endsWith('privaterelay.appleid.com'))
                    ? undefined
                    : viewer.email ?? undefined,
                userId: viewer.uuid,
                createdAt: parseInt(String(new Date(viewer.created_at.iso).getTime() / 1000)),
                name: viewer.name || undefined,
                phone: viewer.phone_number || undefined,
                customAttributes: {
                    user_name: viewer.user_name,
                    email_is_confirmed: viewer.email_is_confirmed,
                    coins: viewer.coins,
                    credits: viewer.credits,
                },
            });
        }
        else {
            update();
        }
    }, [viewer]);
    React.useEffect(() => {
        // send a ping
        updateIntercom();
    }, [location.pathname, viewer]);
    return props.children;
};
export const IntercomWrapper = (props) => {
    if (!browserRootConfig.intercom.app_id) {
        return props.children;
    }
    const is_prerendering = React.useMemo(() => isPrerendering(), []);
    return (_jsx(IntercomProvider, { appId: browserRootConfig.intercom.app_id, autoBoot: !is_prerendering, 
        // delay for 5 seconds before loading intercom. Also helps SEO
        initializeDelay: 5000, children: _jsx(IntercomUpdater, { children: props.children }) }));
};
//# sourceMappingURL=index.js.map